// This component is mainly created to have certain consitency in our stories for Custom Fields

import React from 'react';
import PropTypes from 'prop-types';

const Heading = ({ label, labelFontClassName = undefined }) => {
  return (
    <h3 className={`text-transform: capitalize ${labelFontClassName || 'font-medium text-xl'}`}>{label}</h3>
  );
};

Heading.propTypes = {
  label: PropTypes.string.isRequired,
  labelFontClassName: PropTypes.string,
};

export default Heading;
